var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"remove-past-employer",attrs:{"large":"","icon":""},on:{"click":function($event){_vm.$emit('click')}}},[_c('v-icon',[_vm._v("delete")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }